export default __webpack_public_path__ + "static/media/teacher_login.1766618b.png";